import { FC } from 'react';
import clsx from 'clsx';

import { ViewMain } from 'components/organisms/ViewMain';
import { ContentBody } from 'components/organisms/ContentBody';
import { LevelThreeHero } from 'components/molecules/LevelThreeHero';
import { PageMeta } from 'components/molecules/PageMeta';
import { mapImageContentToOpenGraph } from 'utils/openGraph';
import { extractFirstImageFromContentBody } from 'utils/contentBody';
import { ChapteredSubPageContent } from 'types/contentful/Pages/ChapteredSubPageContent';
import { ContentNavigationList } from 'components/organisms/ContentNavigationList';

interface Props {
  title: string;
  content: ChapteredSubPageContent;
}

const CHAPTER_BACKGROUNDS = ['bg-hrg-', 'bg-hrg-black-5'];

export const ChapteredSubPageView: FC<Props> = ({ content, title }) => (
  <ViewMain footerMargin={false}>
    <PageMeta
      title={title}
      header={content.header}
      openGraph={{
        image: mapImageContentToOpenGraph(
          extractFirstImageFromContentBody(content.chapters.at(0)?.body ?? [])
        ),
      }}
    />

    <LevelThreeHero header={content.header} />
    <div>
      {content.chapters.map((chapter, index) => (
        <article
          key={chapter.id}
          className={clsx('pt-16 first:pt-0', CHAPTER_BACKGROUNDS[index % 2])}
        >
          <h2 className="mb-10 h5 content-wrapper">{chapter.title}</h2>
          <ContentBody
            body={chapter.body}
            className="pb-16 mb-0 tablet:mb-0 tablet:pb-28"
          />
        </article>
      ))}
    </div>
    {content.contentNavigation && (
      <ContentNavigationList
        contentNavigationItems={content.contentNavigation.cards}
      />
    )}
  </ViewMain>
);
